import List from "@/components/treeList";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  // function showDetail({ row }) {
  //   Bus.$emit("details", row);
  // }
  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }
  //删除
  function handleDelete({ row }) {
    Bus.$emit("deleteParam", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "param:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "param:delete"]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "字典类别",
      prop: "type",
      minWidth: "150"
    },
    {
      label: "字典名称",
      prop: "name",
      minWidth: "150"
    },
    {
      label: "数据值",
      prop: "key"
    },
    {
      label: "排序",
      prop: "order",
      minWidth: "80"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "100",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
